'use client'

// /coaching SEO surface (Play A) — the VISIBLE FAQ accordion + the Service and
// FAQPage JSON-LD, all from the ONE source array in utils/coachingSchema.js so the
// machine-readable Q&A can never drift from the on-page copy.
//
// Rendered by app/[[...slug]]/RegionPageClient.jsx ONLY for the coaching route
// (slug === COACHING_ROUTE_SLUG). The two <script type="application/ld+json"> nodes
// are the App-Router-safe raw pattern (next-seo emitters render through next/head
// and throw under App Router SSR — see components/sections/Products/ProductFaq and
// components/seo/SiteJsonLd.app.jsx). The visible FAQ reuses CollapsibleList (the
// same accordion the site FAQ pages use): its answers ship in the SSR HTML even
// while visually collapsed, so Google sees the exact FAQPage text. collapsedListLength
// is set to the item count so every Q&A renders (no "view more" gate).

import React from 'react'
import PropTypes from 'prop-types'

import CollapsibleList from '../sections/CollapsibleList'
import {
  COACHING_FAQS,
  buildCoachingFaqJsonLd,
  buildCoachingServiceJsonLd,
} from '../../utils/coachingSchema'

// One coaching answer string -> a single portable-text block, the shape
// CollapsibleList's CollapsibleItem renders via <SimpleBlockContent>.
function answerBlocks(answer, key) {
  return [
    {
      _type: 'block',
      _key: `${key}-b`,
      style: 'normal',
      markDefs: [],
      children: [{ _type: 'span', _key: `${key}-s`, marks: [], text: answer }],
    },
  ]
}

export default function CoachingSeo({ url }) {
  const serviceJsonLd = buildCoachingServiceJsonLd({ url })
  const faqJsonLd = buildCoachingFaqJsonLd()

  const collapsibleItems = COACHING_FAQS.map((f, i) => {
    const key = `coaching-faq-${i}`
    return { _key: key, title: f.question, text: answerBlocks(f.answer, key) }
  })

  return (
    <>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceJsonLd) }}
      />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <CollapsibleList
        small
        leftAligned
        title="Coaching FAQ"
        collapsibleItems={collapsibleItems}
        collapsedListLength={collapsibleItems.length}
      />
    </>
  )
}

CoachingSeo.propTypes = {
  url: PropTypes.string,
}
